import React, { FC } from "react";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";

import { BusinessSectionNewForm } from "./components/BusinessSectionNewForm";

export const ManagersBusinessSectionsNew: FC = () => {
  const breadCrumbItems = [
    { label: "課設定", href: "/managers/business_sections" },
    { label: "新規作成", href: "/managers/business_sections/new" },
  ];

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        <BusinessSectionNewForm />
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
